import React from "react";

// ui importing
import HomeUI from "../../../../ui/homeUI/_index";

const TaskTotalUI = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default TaskTotalUI;
